'use client'
import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const svgProps = {
    viewBox: '0 0 24 24',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    focusable: 'false',
    'aria-hidden': 'true'
};
function withSVGAttributes(Component) {
    const displayName = Component.displayName || Component.name || 'Component';
    const WrappedComponent = /*#__PURE__*/ forwardRef((props, ref)=>{
        const mergedProps = {
            ...props,
            ...svgProps,
            ref
        };
        return /*#__PURE__*/ jsx(Component, {
            ...mergedProps
        });
    });
    WrappedComponent.displayName = `withSVGAttributes(${displayName})`;
    return WrappedComponent;
}
const SVG_withSVGAttributes = withSVGAttributes;
export { SVG_withSVGAttributes as default, withSVGAttributes };
